<div class="p-7 w-[400px] max-w-[90vw]">
  <p class="text-[16px] font-bold text-[var(--base-text-alt-dark)] mb-2 m-0">Add New Group</p>
  <form [formGroup]="newGroupForm" class="mt-4">
    <label class="block text-[11px] font-semibold text-[var(--base-text-alt-dark)] uppercase tracking-wide mb-1.5">Group Name</label>
    <input type="text" formControlName="group"
      class="w-full py-2.5 px-3 border-[1.5px] border-[var(--app-border)] rounded-lg text-[13px] font-medium text-[var(--base-text-alt-dark)] bg-white outline-none focus:border-[var(--primary-dark)]">
  </form>
  <div class="flex justify-end gap-3 mt-4">
    <button (click)="close()" class="px-5 py-2.5 rounded-lg text-[13px] font-medium text-[var(--base-text-alt-dark)] hover:bg-[var(--app-base)] transition">Cancel</button>
    <button (click)="addGroup()" class="px-5 py-2.5 rounded-lg text-[13px] font-medium bg-[var(--primary-dark)] text-white hover:opacity-90 transition">Save</button>
  </div>
</div>
